import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';


/**
 * A generic input number component that allows to inser a number is various form. 
 * There are several input properties that can customize the input possibilities.
 */
@Component({
  selector: 'input-number',
  standalone: true,
  styleUrl: './input-number.component.css',
  templateUrl: './input-number.component.html',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputNumberComponent,
      multi: true
    }
  ]
})
export class InputNumberComponent implements ControlValueAccessor, OnInit {
  @Input() label = '';
  @Input() required = false;
  @Input() readonly = false;
  @Input() requiredLabel = 'number-required'
  @Input() onlyInteger = false;
  @Input() minValue?: number;
  @Input() maxValue?: number;
  @Input() suffix: string | null = null;
  @Input() formFieldClass: string = '';


  control = new FormControl<number | null>(null);

  onChange = (value: number | null) => { };
  onTouched = () => { };

  ngOnInit(): void {
    const validators = [];

    if (this.required) {
      validators.push(Validators.required);
    }

    if (this.minValue) {
      validators.push(Validators.min(this.minValue));
    }

    if (this.maxValue) {
      validators.push(Validators.max(this.maxValue));
    }

    if (this.onlyInteger) {
      validators.push(this.integerValidator());
    }

    this.control.setValidators(validators);
    // this.control.updateValueAndValidity();

    this.control.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  writeValue(value: number | null): void {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  blockDecimal(event: KeyboardEvent) {
    if (this.onlyInteger && (event.key === '.' || event.key === ',')) {
      event.preventDefault();
    }
  }

  private integerValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === '') return null;
      return Number.isInteger(value) ? null : { notInteger: true };
    };
  }
}
